function getMeetingAnalysisTitle(userName, t) {
  return userName ? t('property_user_meeting_analysis', {
    user: userName
  }) : t('property_meeting_analysis');
}
export default getMeetingAnalysisTitle;